<template>
  <IconLucideCalendarRange />
</template>
